import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  class: "ImportCampaignConfigurationModal"
}
const _hoisted_2 = { class: "ImportCampaignConfigurationContentBlock" }
const _hoisted_3 = { class: "ImportCampaignConfigurationSearchWrapper" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "ImportCampaignConfigurationResultsWrapper" }
const _hoisted_6 = {
  key: 0,
  class: "SpinnerContainer"
}
const _hoisted_7 = {
  key: 0,
  class: "NotFoundContainer"
}
const _hoisted_8 = {
  key: 1,
  class: "ImportCampaignConfigurationValidatingWrapper"
}
const _hoisted_9 = { class: "ImportCampaignConfigurationIneligibleText" }
const _hoisted_10 = { class: "ImportCampaignConfigurationButtonsRow" }
const _hoisted_11 = { class: "ImportCampaignConfigurationDetailsWrapper" }
const _hoisted_12 = { class: "ImportCampaignConfigurationCampaignsBox" }
const _hoisted_13 = { class: "ImportCampaignConfigurationCampaignsRow" }
const _hoisted_14 = { class: "ImportCampaignConfigurationCampaignColumn" }
const _hoisted_15 = { class: "ImportCampaignConfigurationCampaignName" }
const _hoisted_16 = { class: "ImportCampaignConfigurationCampaignMeta" }
const _hoisted_17 = { class: "ImportCampaignConfigurationCampaignMeta" }
const _hoisted_18 = { class: "ImportCampaignConfigurationCampaignColumn" }
const _hoisted_19 = { class: "ImportCampaignConfigurationCampaignName" }
const _hoisted_20 = { class: "ImportCampaignConfigurationCampaignMeta" }
const _hoisted_21 = { class: "ImportCampaignConfigurationCampaignMeta" }
const _hoisted_22 = { class: "ImportCampaignConfigurationReviewTable" }
const _hoisted_23 = { class: "ImportCampaignConfigurationReviewTableValue" }
const _hoisted_24 = { class: "ImportCampaignConfigurationReviewTableValue" }
const _hoisted_25 = { class: "ImportCampaignConfigurationReviewTableValue" }
const _hoisted_26 = {
  key: 0,
  class: "ImportCampaignConfigurationNotice ImportCampaignConfigurationNoticeWarning"
}
const _hoisted_27 = {
  key: 1,
  class: "ImportCampaignConfigurationNotice ImportCampaignConfigurationNoticePositive"
}
const _hoisted_28 = { class: "ImportCampaignConfigurationButtonsRow" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 0,
  ref: "importButton",
  "data-style": "zoom-in",
  class: "ChampionButton ImportCampaignConfigurationButton"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_SearchResultItem = _resolveComponent("SearchResultItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "ImportCampaignConfigurationHeaderBlock" }, [
      _createElementVNode("h3", { class: "ImportCampaignConfigurationModalTitle" }, "Import campaign configuration")
    ], -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.step === 'search')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[6] || (_cache[6] = _createElementVNode("label", {
              class: "CampaignEditorInputLabel",
              for: "ImportCampaignConfigurationSearchBar"
            }, " Search for a campaign to import ", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("input", {
                id: "ImportCampaignConfigurationSearchBar",
                class: "CampaignEditorInputField ImportCampaignConfigurationSearchInput",
                type: "text",
                ref: "searchInput",
                placeholder: "Search by campaign name / ID",
                onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"]), ["enter"]))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
              _createElementVNode("button", {
                class: "ImportCampaignConfigurationSearchButton",
                "aria-label": "Search campaigns",
                title: "Search campaigns",
                disabled: _ctx.showSpinner,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
              }, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("i", { class: "lnr-magnifier ImportCampaignConfigurationSearchButtonIcon" }, null, -1 /* CACHED */),
                _createTextVNode(" Search ", -1 /* CACHED */)
              ]))], 8 /* PROPS */, _hoisted_4)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.showSpinner)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_Spinner)
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (!_ctx.searchResults.length && _ctx.searchTerm)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, " No campaigns found. "))
                      : _createCommentVNode("v-if", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (campaign) => {
                      return (_openBlock(), _createBlock(_component_SearchResultItem, {
                        key: campaign.id,
                        campaign: campaign,
                        onSelect: _ctx.selectCampaign
                      }, null, 8 /* PROPS */, ["campaign", "onSelect"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 64 /* STABLE_FRAGMENT */))
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : (_ctx.isValidatingEligibility)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_Spinner),
              _cache[7] || (_cache[7] = _createElementVNode("p", { class: "ImportCampaignConfigurationValidatingText" }, " Checking if this campaign can be imported... ", -1 /* CACHED */))
            ]))
          : (_ctx.eligibility && !_ctx.eligibility.isEligible)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.ineligibleMessage), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    class: "NavigatorButton ImportCampaignConfigurationButton",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.backToSearch && _ctx.backToSearch(...args)))
                  }, " Back to search ")
                ])
              ], 64 /* STABLE_FRAGMENT */))
            : (_ctx.eligibility && _ctx.eligibility.isEligible)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[16] || (_cache[16] = _createElementVNode("p", { class: "ImportCampaignConfigurationSectionTitle" }, "Evaluate import", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _cache[8] || (_cache[8] = _createElementVNode("label", { class: "CampaignEditorInputLabel" }, "Source campaign", -1 /* CACHED */)),
                          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.eligibility.details.sourceCampaignName), 1 /* TEXT */),
                          _createElementVNode("p", _hoisted_16, "Campaign ID: " + _toDisplayString(_ctx.eligibility.details.sourceCampaignId), 1 /* TEXT */),
                          _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.formattedSourceDateRange), 1 /* TEXT */)
                        ]),
                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "ImportCampaignConfigurationCampaignArrow" }, "→", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_18, [
                          _cache[9] || (_cache[9] = _createElementVNode("label", { class: "CampaignEditorInputLabel" }, "Target campaign", -1 /* CACHED */)),
                          _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.eligibility.details.destinationCampaignName), 1 /* TEXT */),
                          _createElementVNode("p", _hoisted_20, "Campaign ID: " + _toDisplayString(_ctx.eligibility.details.destinationCampaignId), 1 /* TEXT */),
                          _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.formattedDestinationDateRange), 1 /* TEXT */)
                        ])
                      ])
                    ]),
                    _cache[17] || (_cache[17] = _createElementVNode("p", { class: "ImportCampaignConfigurationSectionTitle" }, "Configuration review", -1 /* CACHED */)),
                    _createElementVNode("table", _hoisted_22, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _cache[11] || (_cache[11] = _createElementVNode("td", { class: "ImportCampaignConfigurationReviewTableLabel" }, "Linked organisations", -1 /* CACHED */)),
                          _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.eligibility.details.amountLinkedOrganisations), 1 /* TEXT */)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[12] || (_cache[12] = _createElementVNode("td", { class: "ImportCampaignConfigurationReviewTableLabel" }, "Selected entities", -1 /* CACHED */)),
                          _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.eligibility.details.amountAttachedEntities), 1 /* TEXT */)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[13] || (_cache[13] = _createElementVNode("td", { class: "ImportCampaignConfigurationReviewTableLabel" }, "Geotargeting settings", -1 /* CACHED */)),
                          _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.eligibility.details.hasGeotargetedEntities ? 'Yes' : 'No'), 1 /* TEXT */)
                        ])
                      ])
                    ]),
                    (_ctx.eligibility.destinationHasExistingConfigs)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [...(_cache[14] || (_cache[14] = [
                          _createElementVNode("i", { class: "lnr-info ImportCampaignConfigurationNoticeIcon" }, null, -1 /* CACHED */),
                          _createElementVNode("span", null, " The destination campaign already has organisations, entities or geotargeting configured. Importing will replace the existing configuration. ", -1 /* CACHED */)
                        ]))]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_27, [...(_cache[15] || (_cache[15] = [
                          _createElementVNode("i", { class: "lnr-checkmark-circle ImportCampaignConfigurationNoticeIcon" }, null, -1 /* CACHED */),
                          _createElementVNode("span", null, "No overlapping campaign assignments detected. All imported entities can be assigned to this campaign.", -1 /* CACHED */)
                        ]))]))
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("button", {
                      class: "NavigatorButton ImportCampaignConfigurationButton",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.backToSearch && _ctx.backToSearch(...args))),
                      disabled: _ctx.isImporting
                    }, " Back to search ", 8 /* PROPS */, _hoisted_29),
                    (_ctx.isImporting)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_30, null, 512 /* NEED_PATCH */))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "ChampionButton ImportCampaignConfigurationButton",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.confirmImport && _ctx.confirmImport(...args)))
                        }, " Import configuration "))
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
    ])
  ], 512 /* NEED_PATCH */))
}